const debug = require('debug')('jp:clientMiddleware');

export default function clientMiddleware(client) {
  return ({ dispatch, getState }) => next => action => {
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }

    const {
      promise,
      types,
      shouldCallApi = () => __SERVER__ || true,
      ...rest
    } = action; // eslint-disable-line no-redeclare
    if (!promise) {
      return next(action);
    }

    const [REQUEST, SUCCESS, FAILURE] = types;

    if (!shouldCallApi(getState())) {
      return undefined;
    }

    next({ ...rest, type: REQUEST });
    const actionPromise = promise(client);

    return actionPromise
      .then(
        payload => next({ ...rest, payload, type: SUCCESS }),
        payload => next({ ...rest, payload, type: FAILURE })
      )
      .catch(error => {
        debug('MIDDLEWARE ERROR:', error);
        next({ ...rest, error, type: FAILURE });
      });
  };
}
